import * as React from "react";
import { inject, observer } from "mobx-react";
import { AppProps } from "../../stores/storeContract";
import "./Chart.scss";

interface AppPropsChart extends AppProps {  
    symbol?: string,
    interval?: number
}

@inject("commonStore", "formatStore", "symbolStore")
@observer
export default class Chart extends React.Component<AppPropsChart> {
    
    componentDidMount() {
           
        var symbol = this.props.symbol;
        var interval = this.props.formatStore.formatChartInterval(this.props.interval);
        
        new (window as any).TradingView.widget(
            {
            "autosize": "true",
            "symbol": "BITFINEX:" + this.props.symbolStore.formatChartSymbol(symbol),
            "interval": interval,
            "timezone": "Etc/UTC",
            "theme": this.props.commonStore.darkTheme ? "dark" : "light",
            "style": "1",
            "locale": "en",
            "toolbar_bg": "#f1f3f6",
            "enable_publishing": false,
            "hide_top_toolbar": true,
            "hide_legend": true,
            "save_image": false,
            "container_id": "tradingview_" + symbol
            }
        );
    }

   	render() {

        const symbol = this.props.symbol;
        //const { formatSymbol, formatChartSymbol } = this.props.symbolStore;
        var identifier = 'tradingview_' + symbol;
        
        return (
			<div className="chart">
                <div className="tradingview-widget-container">
                    <div id={identifier}></div>
                    {/* <div className="tradingview-widget-copyright">
                        <a href={'https://www.tradingview.com/symbols/' + formatChartSymbol(symbol) + '/?exchange=BITFINEX'} rel="noopener" target="_blank">
                            <span className="blue-text">{formatSymbol(symbol)} Chart</span>
                        </a> by TradingView
                    </div>  */}
                </div>
			</div>
		);
	}
}